export default "__VITE_ASSET__Cq0_p63P__"